module.exports = __webpack_public_path__ + "img/和讯.5df5236f.png";